// Listing-tile binders re-sweep the document on each render: bind each handler once.
const bindOnce = (element, event, key, handler) => {
  const marker = `vjsBound${key}`
  if (element.dataset[marker]) return

  element.dataset[marker] = 'true'
  element.addEventListener(event, handler)
}

export default bindOnce
